// extracted by mini-css-extract-plugin
export var changeIcon = "_5o-4";
export var container = "_5o-0";
export var divider = "_5o-7";
export var externalLinkIcon = "_5o-1";
export var green = "_5o-5";
export var helpCircleIcon = "_5o-3";
export var iconButton = "_5o-2";
export var red = "_5o-6";